import React from 'react'
import Layout from '../../components/Layout/Layout'
import RestaurantsPage from '../../pages/RestaurantsPage/RestaurantsPage'

function App() {
  return (
    <Layout>
      <RestaurantsPage />
    </Layout>
  )
}

export default App
